import { RootState } from '../store';

export const selectUIReducer = ({ uiReducer }: RootState) => uiReducer;
